/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import { ISearchResultsStateManager, ISearchResultsList, ISearchResults, IPaginationInfo } from './contracts'
import { injectable } from 'inversify'
import { observable, action, computed } from 'mobx'
import { injectProperty } from '../../configuration/ServiceLocator'
import ISearchResultsApiClient from '../SearchResultsApiClient/contracts'
import { ValidationResult } from '../../../src/utils/ValidationResult/ValidationResult'
import { isEmpty } from 'validator'

@injectable()
export class SearchResultsStateManager implements ISearchResultsStateManager {
	@observable
	results: ISearchResultsList

	@observable
	paginationInfo: IPaginationInfo

	@observable
	searchTerm: string

	@injectProperty('ISearchResultsApiClient')
	public searchResultApiClient!: ISearchResultsApiClient

	/**
	 *
	 */
	constructor () {
		this.results = { total: 0, items: [] } as ISearchResultsList
		this.searchTerm = ''
		this.paginationInfo = { pageIndex: 0 } as IPaginationInfo
	}

	@action setSearchResults(results: ISearchResultsList, skip: number): void {
		if (skip > 0) {
			this.results.items = [...this.results.items, ...results.items]
			this.results.total = this.results.total + results.total
		}
		else {
			this.results.items = results.items
			this.results.total = results.total
		}
	}

	getPublishDateStr(utcDate: any): string {
		if (utcDate && utcDate != '') {
			const date = new Date(utcDate)
			return `${date.toLocaleString('default', { month: 'long' })} ${date.getDate()}, ${date.getFullYear()}`
		}
		return ''
	}

	@action setSearchTerm(searchTerm: string): void {
		this.searchTerm = searchTerm
	}

	@computed get validateSearchTerm(): ValidationResult {
		const result = new ValidationResult()
		if (isEmpty(this.searchTerm)) {
			result.setMessage('searchTerm', 'Search field is required.')
		}
		return result
	}


	@action getSearchResults(searchTerm: string, first: number, skip: number, searchType: string): Promise<void> {
		/**Added this for avoiding the multiple time state updates  */

		return this.searchResultApiClient
			.getSearchResults(searchTerm, first, skip)
			.then(response => {
				if (response.total > 0)
					this.setSearchResults(response, skip)
				else
					if (searchType != "scroll")
						this.setSearchResults(response, skip)
					else
						this.results.total = 0;
			})
			.catch(error => {
				console.log(error)
				throw new Error('An error occurred when fetching the search results')
			})
	}
}
